import { connect } from "react-redux";

import {
    reloadForm,
    UploadedFileInfo,
    uploadFileAction,
    uploadFufFileAction,
    importXmlsAction,
} from "../../../../ActionCreators/FufUploadActionCreator";
import { CandyDispatch } from "../../../Store/CandyReduxTypes";
import { CustomFile } from "../../../../../Helpers/file";
import { FullFormState } from "../../../Store/FullFormState";
import {
    CombinatorType,
    CombineFufResult,
    FufCombineMethod,
} from "../../../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";

import { NdflInquiryUpload } from "./NdflInquiryUpload";

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
    modalSettings: state.modalState,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    getFileProperties: (file: CustomFile | undefined): Promise<UploadedFileInfo> => dispatch(uploadFufFileAction(file)),
    uploadFile: (): Promise<CustomFile | undefined> => dispatch(uploadFileAction),
    reloadForm: (path?: string): void => reloadForm(path),
    importXmls: (
        driveUris: string[],
        combineMethod: FufCombineMethod,
        combinatorType: CombinatorType,
        isImportByFuf: boolean,
        args?: string[]
    ): Promise<CombineFufResult | undefined> =>
        dispatch(importXmlsAction(driveUris, combineMethod, combinatorType, isImportByFuf, args)),
});

export const NdflInquiryUploadContainer = connect(mapStateToProps, mapDispatchToProps)(NdflInquiryUpload);
